export { default as GenerateBillConfirmation } from "./GenerateBillConfirmation";
export type {
    IGenerateBillConfirmationProps,
    IGenerateBillCTA,
    IGenerateBillContentProps,
} from "./types";
